import { Injectable } from '@angular/core';
import { WebSdkService } from 'src/app/shared/services/web-sdk/web-sdk.service';
import { DatacontextService } from 'src/app/data/datacontext.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class TrialUserService {
  private companyDetails: any = {};
  public trialUserData: any = {};
  private trialStDt: any;
  private dilWhitelist: any = [];
  private trialWhiteList: any = [];

  constructor(private webSdkService: WebSdkService,
    private datacontextService: DatacontextService,
    private authenticationService: AuthenticationService) {
    if (Object.keys(this.trialUserData).length === 0 && !this.authenticationService.isIframe()) {
      this.getCompanyInfo();
    }
    // setting isTrialUser flag to false.
    this.trialUserData.istrialUser = false;
  }

  getCompanyInfo() {
    this.datacontextService.user.getUserCompany((res: any) => {
      const _companyDetails = res.api_response.companies[0];
      delete _companyDetails.apps;
      this.companyDetails = _companyDetails;

      const isSDKReady = window.setInterval(() => {
        if (this.webSdkService.sdkReady) {
          window.clearInterval(isSDKReady);
          this.getTrialStartDate();
        }
      }, 1000);

    });
  }

  checkTrialUser() {
    const trialStartDate = new Date(this.trialStDt);
    const ts = this.companyDetails.ts;
    const userCreateData = new Date(ts);
    const isUserWhitelisted = this.trialWhiteList.includes(this.companyDetails.id);
    this.trialUserData.istrialUser = false;
    this.trialUserData.enableDIL = this.dilWhitelist.includes(this.companyDetails.id);
    if (this.trialUserData.istrialUser) {
      this.getTrialPeriodCounDown(userCreateData);
    }
  }

  getTrialPeriodCounDown(dateCreated) {
    const next30days = new Date(dateCreated.setDate(dateCreated.getDate() + 30));
    const today = new Date();
    const diffTime = next30days.getTime() - today.getTime();
    this.trialUserData.trialDaysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  private getTrialStartDate() {
    this.webSdkService.getData('string', 'trialStartDate', '').then((date: any) => {
      this.trialStDt = date;
      this.getTrialWhiteList();
      // this.checkTrialUser(date);
    });
  }

  private getTrialWhiteList() {
    this.webSdkService.getData('JSON', 'trial-whitelist', []).then((trialWhiteList: any) => {
      this.trialWhiteList = trialWhiteList;
      this.getDILWhiteList();
    });
  }

  private getDILWhiteList() {
    this.webSdkService.getData('JSON', 'dil-whitelist', []).then((whitelist: any[]) => {
      this.dilWhitelist = whitelist;
      this.checkTrialUser();
    });
  }
}
